
















import { Vue, Component } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import NoPage from "../../components/Error/NoPage.vue";
import { InstituteInfo } from "../../_models/instituteInfo";
import RequestsDataTable from "../../components/DataTables/RequestsDataTable.vue";
import CardTitle from "../../components/CardTitle.vue";
import { RichiestaAlternanza } from "../../_models/richiestaAlternanza";
import * as temp from "../../_store/temp.module";

@Component({
  components: {
    NoPage,
    RequestsDataTable,
    CardTitle
  }
})
export default class GestioneAlternanza extends Vue {
  private createParams: object;
  private dataTableParams: any;
  private titleParams: object;

  private listaInformazioniAlternanza: any;

  constructor() {
    super();
    this.titleParams = {
      title: "RICHIESTE FSL",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.createParams = {
      visible: false,
      type: "",
      idIstituto: 0,
      idAnnoScolastico: 0,
      idAziendaIstitutoAnno: 0
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Azienda Richiedente",
          value: "denominazioneAzienda"
        },
        {
          text: "Sede Attività",
          value: "comuneTirocinio"
        },
        {
          text: "Indirizzo Studio Richiesta",
          value: "nomeIndirizzoStudio"
        },
        {
          text: "Nome Tirocinante Indicato",
          value: "nomeTirocinante"
        },
        {
          text: "Cognome Tirocinante Indicato",
          value: "cognomeTirocinante"
        },
        {
          text: "Classe Tirocinante Indicato",
          value: "classeTirocinante",
          width: "1%"
        },
        {
          text: "Utilizzata",
          value: "utilizzata",
          width: "1%"
        },
        {
          text: "Visualizza",
          value: "actionInstitute",
          sortable: false,
          width: "1%"
        },
        {
          text: "Note Azienda",
          value: "noteAzienda",
          sortable: false,
          width: "1%"
        },
        {
          text: "Visita Preliminare",
          value: "ispezioneAzienda",
          sortable: false,
          width: "1%"
        },
        // {
        //   text: "Note",
        //   value: "noteRichiesta",
        //   sortable: false,
        //   width: "1%"
        // },
        {
          text: "Elimina Richiesta",
          value: "eliminaRichiesta",
          sortable: false,
          width: "1%"
        },
        {
          text: "Stato Richiesta",
          value: "statoAccettazioneRichiesta",
          width: "1%"
        }
        // {
        //   text: "Modifica Disponibilità",
        //   value: "editRichiesta",
        //   sortable: false
        // }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI FSL",
        type: "richiestaAlternanzaTab"
      },
      type: "alternanza",
      filterType: "listaRichiesteAttivita"
    };
  }

  loadRichiesteAlternanza(idAnnoScolastico: number) {
    // var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchInformazioniAlternanza(this["$store"], payload)
      .then(result => {
        this.listaInformazioniAlternanza = result;
        this.dataTableParams.records = result;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 401) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            this.createParams = {
              visible: false,
              type: "",
              idIstituto: user.readInstituteInfo(this["$store"]).id,
              idAnnoScolastico: 0,
              idAziendaIstitutoAnno: 0
            };
            this.loadRichiesteAlternanza(idAnnoScolastico);
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("changeAnnoScolastico", (payload: any) => {
      this.loadRichiesteAlternanza(payload);
    });

    bus.$on("refreshAlternanzaTable", () =>{
      var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
      this.loadRichiesteAlternanza(idAnnoScolastico)
    })

    bus.$on("filtroRichiesteAlternanza", (filters: any) =>{
      const listaRichieste: any = this.listaInformazioniAlternanza;
      var tempList: any = [];
      this.dataTableParams.records = [];
      listaRichieste.forEach((richiesta: any) => {
        if (filters.filtroUtilizzata !== "Tutte") {
          if (filters.filtroUtilizzata === "Utilizzate"){
            if (richiesta.utilizzata === true){
              tempList.push(richiesta);
            }
          } else if(filters.filtroUtilizzata === "Non Utilizzate"){
            if(richiesta.utilizzata === false){
              tempList.push(richiesta);
            }
          }
        }else{
          tempList.push(richiesta);
        }
      });
      this.dataTableParams.records = tempList;
    })
  }
}
